import { render, staticRenderFns } from "./PenunjukanKerjaDetail.vue?vue&type=template&id=165278f2&scoped=true&lang=html&"
import script from "./PenunjukanKerjaDetail.vue?vue&type=script&lang=js&"
export * from "./PenunjukanKerjaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165278f2",
  null
  
)

export default component.exports